<!-- TODO check the w-full issue -->
<div class="flex flex-col w-full gap-6">
  <div class="flex flex-col pt-6 md:pt-12">
    <div class="flex justify-between">
      <div class="flex-col">
        <h1 class="text-xl md:text-4xl text-gray-900 pb-1">
          Welcome <span class="font-semibold">Sophia</span>
        </h1>
        <p class="text-md text-gray-600 text-left pb-8">
          Your business summary.
        </p>
      </div>
      <div>
        <!-- <img [src]="assetUrl + 'icons/bell.svg'" alt=""> -->
      </div>
    </div>
    <div class="flex justify-end">
      <glo-option-switch
        [options]="periodOptions"
        (changed)="onPeriodChange($event)"
      ></glo-option-switch>
    </div>
  </div>
  <div class="flex gap-4 w-full justify-between">
    <div class="flex w-full flex-col md:flex-row gap-4 md:w-full">
      <div
        class="flex w-full md:w-1/2 rounded-2xl justify-between bg-white border border-gray-200 rounded-lg p-5"
      >
        <div class="flex flex-col">
          <span class="text-sm text-gray-600 pb-2">Appointments Booked</span>
          <span class="text-3xl font-semibold">9</span>
        </div>
        <div>
          <img
            [src]="assetUrl + 'icons/calendar-border.svg'"
            class="w-[52px] h-[52px]"
            alt=""
          />
        </div>
      </div>
      <div
        class="flex w-full md:w-1/2 rounded-2xl justify-between bg-white border border-gray-200 rounded-lg p-5"
      >
        <div class="flex flex-col">
          <span class="text-sm text-gray-600 pb-2">Page views</span>
          <span class="text-3xl font-semibold">23,300</span>
        </div>
        <div>
          <img
            [src]="assetUrl + 'icons/eye-border.svg'"
            class="w-[52px] h-[52px]"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-col lg:flex-row gap-6">
    <div
      class="flex w-full lg:w-1/2 justify-between bg-white border border-gray-200 rounded-lg p-6"
    >
      <div class="flex flex-col gap-0.5">
        <span class="text-lg font-semibold">January 2026</span>
        <span class="text-sm text-gray-600">Jan 1, 2026 - Jan 31, 2026</span>
      </div>
      <button
        class="px-6 py-2 shadow rounded-3xl bg-white text-gray-950 btn-hover"
      >
        View All
      </button>
    </div>
    <div
      class="flex flex-col w-full lg:w-1/2 justify-between p-6 items-center bg-white border border-gray-200 rounded-lg"
    >
      <div class="flex w-full pb-6 justify-between">
        <h3 class="flex text-lg items-center">Upcoming Appointments</h3>
        <span class="flex items-center gap-1">
          <button
            class="px-6 py-2 shadow rounded-3xl bg-white text-gray-950 btn-hover"
          >
            View All
          </button>
        </span>
      </div>
      <div class="flex flex-col">
        @if (appointments.length === 0) {
          <glo-empty node="appointments"></glo-empty>
        } @else {
          <div class="flex border rounded-lg items-center p-4 w-full">
            <!-- Date Box -->
            <div
              class="flex flex-col w-[52px] self-start text-center justify-center text-white rounded-lg border border-gray-200 mr-3 overflow-hidden"
            >
              <div
                class="text-xs font-semibold font-medium bg-error-500 text-white w-full text-center"
              >
                Fri
              </div>
              <div class="text-md font-bold">10</div>
            </div>

            <!-- Main Info Section -->
            <div class="flex flex-col flex-1">
              <div class="flex items-center gap-2">
                <div class="text-sm text-gray-600">Wed 10:00AM</div>
                <span
                  class="flex text-sm border rounded-full px-2 py-0.5 mr-2 border-success-200 bg-success-50 text-success-700 items-center gap-1"
                >
                  <img [src]="assetUrl + 'icons/dot-green.svg'" alt="" />
                  Booked
                </span>
              </div>
              <div class="text-md font-semibold">Hair Coloring</div>
              <div class="text-sm text-gray-500">
                Sophia Valerie • 45 min with Catline
              </div>
            </div>

            <!-- Price -->
            <div class="text-base font-semibold">$40</div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
